/**系统授权模块 */
import request from '../request/http';
/**获取虚仿平台授权租户 */
export function SchoolSelect(data){
    return request({
        url: '/sp/authHandle/queryTenantInfo',
        method: 'post',
        data
    })
}
//虚仿平台用户注册
export function Register(data){
    return request({
        url: '/sp/authHandle/register' ,
        method: 'post',
        data: data
    })
}
//同步用户登录信息
export function SyncUserInfo(){
    return request({
        url: '/sp/authHandle/syncLogin' ,
        method: 'post',
    })
}
/**分页查询虚仿平台授权租户 */
export function PageQueryTenantInfo(data){
    return request({
        url: '/sp/authHandle/pageQueryTenantInfo' ,
        method: 'post',
        data
    })
} 